import './shared'
import Router from 'live/services/router'
import Examples from './examples/Examples'
import ExampleHeader from './examples/ExampleHeader'
import ExampleListHeader from './examples/ExampleListHeader'
import ExampleFormHeader from './examples/ExampleFormHeader'
import ExampleNavbar from './examples/ExampleNavbar'
import DropdownFilters from './examples/ExampleDropdownFilters'
import i18n from 'live/services/i18n'
import enUs from './i18n/en_us'
import ptBr from './i18n/pt_br'

// http://localhost:8080/#/mobility-utils
Router.route('mobility-utils', Examples, 'mobility-utils')
Router.route('mobility-utils/header', ExampleHeader, 'mobility-utils/header')
Router.route('mobility-utils/navbar', ExampleNavbar, 'mobility-utils/navbar')
Router.route('mobility-utils/list-header', ExampleListHeader, 'mobility-utils/list-header')
Router.route('mobility-utils/form-header', ExampleFormHeader, 'mobility-utils/form-header')
Router.route('mobility-utils/dropdown-filters', DropdownFilters, 'mobility-utils/fdropdown-filters')

const locale = window.Live.settings && window.Live.settings.locale ? window.Live.settings.locale : 'pt_br'
const localeFiles = {
    pt_br: ptBr,
    en_us: enUs
}

i18n.add(localeFiles[locale])
